export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '操作',
            prop: 'updateType',
            type: 'select',
            optionsKey: 'MODIFY_RECORD_UPDATE_TYPE',
            headerType: 'select',
            params: {
                params: {
                    optionsKey: 'MODIFY_RECORD_UPDATE_TYPE'

                }
            }
        },
        {
            label: '修改内容',
            headerType: 'input',
            prop: 'updateFieldName'
        },
        {
            label: '旧值',
            prop: 'oldValue',
            sort: true
        },
        {
            label: '新值',
            prop: 'newValue',
            sort: true
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            sort: true
        },
        {
            label: '修改人',
            headerType: 'input',
            prop: 'updateUserName'
        },
        {
            label: '修改美信号',
            prop: 'updateUserCode'
        }
    ]
};
